


































import Vue from 'vue'
import store from '@/store'
import bus from '@/services/bus'
import config from '@/config'
import {HIDE_SIDEBAR_LINKS} from '@/constants';

export default Vue.extend({
  props: {
    id: String
  },
  computed: {
    student (): any {
      return this.$store.state.students.students[this.id].data
    },
    showSchedule () {
      if (!config(HIDE_SIDEBAR_LINKS)) {
        return true
      }

      return !config(HIDE_SIDEBAR_LINKS).includes('sched');
    },
    activeTab: {
      get (): string {
        return this.$route.name!
      },
      set () {

      }
    }
  },
  async beforeRouteEnter (to, from, next) {
    try {
      await store.dispatch('students/loadStudent', to.params.id)
      // @ts-ignore
      bus.$emit('pathChanged')
      next()
    } catch (error) {
      next('notFound')
    }
  }
})
